module.exports = __webpack_public_path__ + "static/music.3277b61f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/music.jpg
// module id = 356
// module chunks = 35783957827783